"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _appActions = require("../appActions");
var _userActions = require("./userActions");
const initialState = {
  marketingId: 1,
  userSession: null,
  isUserSessionLoaded: false,
  isSavingUserSession: false,
  isUserSessionFinalized: false
};
const userReducer = function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  let {
    type,
    payload
  } = arguments.length > 1 ? arguments[1] : undefined;
  switch (type) {
    case _userActions.CREATE_USER_SESSION_SUCCESS:
      return {
        ...state,
        marketingId: payload.marketingId,
        userSession: payload.userSession,
        isUserSessionLoaded: true,
        isUserSessionFinalized: true
      };
    case _appActions.INJECT_STATE:
      return {
        ...state,
        isUserSessionFinalized: true
      };
    case _userActions.FETCH_USER_SESSION_SUCCESS:
      return {
        ...state,
        marketingId: payload.marketingId,
        userSession: payload.userSession,
        isUserSessionLoaded: true
      };
    case _userActions.SAVE_USER_SESSION:
      return {
        ...state,
        isSavingUserSession: true
      };
    case _userActions.SAVE_USER_SESSION_SUCCESS:
      return {
        ...state,
        userSession: payload.userSession,
        isSavingUserSession: false
      };
    case _userActions.SAVE_USER_SESSION_ERROR:
      return {
        ...state,
        isSavingUserSession: false
      };
    default:
      return state;
  }
};
var _default = userReducer;
exports.default = _default;